<template>
<!-- v-if="computedPayload.length" -->
  <div class="our-approach__cards" >
    <div class="our-approach__card">
      <h3 class="our-approach__card-title"><slot name="title" /></h3>
      <p class="our-approach__card-text"><slot name="text" /></p>

      <div :class="['our-approach__card-dropdown-panel',{'active':toggleRead}]">
        <ul class="our-approach__card-list">
          <li v-for="item in computedPayload" :key="item">
            <div class="our-approach__card-list-img-container">
              <svg v-if="icon_style === 'check'" class="our-approach__card-list-img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="#44ae60">
                <path fill-rule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clip-rule="evenodd" />
              </svg>
              <svg v-if="icon_style === 'check-circle'" class="our-approach__card-list-img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="#44ae60">
                <path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clip-rule="evenodd" />
              </svg>
            </div>
            <p class="our-approach__card-list-text">{{ item }}</p>
          </li>
        </ul>
      </div>
      <label :for="randomId" class="our-approach__card-dropdown-label" @click="toggleRead = !toggleRead">
        <span>{{ readMoreLess }}</span>
      </label>
    </div>
  </div>
</template>

<script>
	export default {
		props: {
			payload: {
				type: String
			},
      icon_style: {
				type: String,
				default: 'check-circle'
			}
		},

    data() {
      return {
        toggleRead: false,
      }
    },

    mounted() {
      console.log('THE PAYLOAD', this.computedPayload);
    },

		computed: {
      computedPayload() {
        return typeof this.payload === 'string' ? JSON.parse(this.payload) : this.payload;
      },
      randomId() {
        return Math.random().toString(36).substr(2, 5) + Date.now();
      },
      readMoreLess() {
        return this.toggleRead ? 'Read Less' : 'Read More';
      }
		}    
	}
</script>
